import { render, staticRenderFns } from "./TerminalList.vue?vue&type=template&id=5d0704d6&scoped=true"
import script from "./TerminalList.vue?vue&type=script&lang=js"
export * from "./TerminalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0704d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d0704d6')) {
      api.createRecord('5d0704d6', component.options)
    } else {
      api.reload('5d0704d6', component.options)
    }
    module.hot.accept("./TerminalList.vue?vue&type=template&id=5d0704d6&scoped=true", function () {
      api.rerender('5d0704d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/systemSet/TerminalList.vue"
export default component.exports